import { gql } from "@apollo/client";

export const GET_MOTIVOS_BLOQUEO_CREDITICIO = gql`
query allMotivosCrediticia{
    allMotivosCrediticia {
        idMotivoResolucionCrediticia,
        motivoBloqueo
    }
  }
`;

export const adaptMotivoBloqueoCrediticia = (motivo) => ({
  id: motivo.idMotivoResolucionCrediticia,
  displayName: motivo.motivoBloqueo
});

export const adaptMotivoBloqueoCrediticiaArray = (motivos) =>
structuredClone(motivos?.allMotivosCrediticia)?.
map((motivo) => adaptMotivoBloqueoCrediticia(motivo));